<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
      data () {
          return {}
      }
  }
</script>

<style>
  @import "assets/css/reset.css";

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    padding: 0;
    margin: 0 auto;
    height: 100%;
    overflow: hidden;
  }

  a > img, p > img {
    pointer-events: auto;
  }

  /*@media screen and (min-width: 750px) {*/
    /*#app {*/
      /*width: 375px;*/
    /*}*/
  /*}*/
</style>
